// capitalGainSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { buildAuthHeaders, getAccessToken } from '../utils/authHeaders';

const apiUrl = process.env.REACT_APP_API_URL;
export const fetchCapitalGainsShortPeriod= createAsyncThunk(
  'capitalGains/fetchCapitalGainsShortPeriod',
  async (_, { getState }) => {
    const { clientId, financialYear } = getState().app;
    const accessToken = getAccessToken(getState().auth?.access_token);
    const response = await fetch(`${apiUrl}/api/cg/duration/stcg?clientId=${clientId}&financialYear=${financialYear}`, {
      headers: buildAuthHeaders(accessToken),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch capital gains Short duration data');
    }
    const data = await response.json();
    return data;
  }
);

export const fetchCapitalGainsLongPeriod= createAsyncThunk(
  'capitalGains/fetchCapitalGainsLongPeriod',
  async (_, { getState }) => {
    const { clientId, financialYear } = getState().app;
    const accessToken = getAccessToken(getState().auth?.access_token);
    const response = await fetch(`${apiUrl}/api/cg/duration/ltcg?clientId=${clientId}&financialYear=${financialYear}`, {
      headers: buildAuthHeaders(accessToken),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch capital gains Long duration data');
    }
    const data = await response.json();
    return data;
  }
);

export const fetchCapitalGains = createAsyncThunk(
  'capitalGains/fetchCapitalGains',
  async (_, { getState }) => {
    const { clientId, financialYear } = getState().app;
    const accessToken = getAccessToken(getState().auth?.access_token);
    const response = await fetch(`${apiUrl}/api/cg/capitalGains?clientId=${clientId}&financialYear=${financialYear}`, {
      headers: buildAuthHeaders(accessToken),
    });
    if (!response.ok) {
      throw new Error('Failed to fetch capital gains data');
    }
    const data = await response.json();
    return data;
  }
);

const capitalGainSlice = createSlice({
  name: 'capitalGains',
  initialState: {
    ltcg: [],
    ltcgTotal: 0,
    ltcgTaxableTotal: 0,
    ltcgThresholdRelief: 0,
    stcg: [],
    stcgTotal: 0,
    stcgTaxableTotal: 0,
    stcgPeriod:[],
    ltcgPeriod:[],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCapitalGains.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCapitalGains.fulfilled, (state, action) => {
        state.loading = false;
        state.ltcg = action.payload.ltcg;
        state.ltcgTotal = action.payload.ltcgTotal;
        state.ltcgTaxableTotal = action.payload.ltcgTaxableTotal;
        state.ltcgThresholdRelief = action.payload.ltcgThresholdRelief;
        state.stcg = action.payload.stcg;
        state.stcgTotal = action.payload.stcgTotal;
        state.stcgTaxableTotal = action.payload.stcgTaxableTotal;
      })
      .addCase(fetchCapitalGains.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchCapitalGainsShortPeriod.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCapitalGainsShortPeriod.fulfilled, (state, action) => {
        state.loading = false;
        state.stcgPeriod = action.payload;
        
      })
      .addCase(fetchCapitalGainsShortPeriod.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchCapitalGainsLongPeriod.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCapitalGainsLongPeriod.fulfilled, (state, action) => {
        state.loading = false;
        state.ltcgPeriod = action.payload;
        
      })
      .addCase(fetchCapitalGainsLongPeriod.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      ;
  },
});

export default capitalGainSlice.reducer;
